import { useState } from "react";
import { itemdetails } from "../../data/itemdetails";



const ItemDetails = () => {
    
    const [item] = useState(itemdetails);

    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 py-10 sm:py-20">
           
            <div className="flex flex-col md:flex-row justify-between mb-10 sm:mb-20">

                <div className="md:w-[48%] mb-20">
                    <img src = {item.image} alt = 'auction' className="w-[100%]"/>
                </div>

                <div className="md:w-[48%] md:h-[70vh] overflow-auto custom_scrollbar flex flex-col lg:flex-row lg:justify-between">
                    
                    <div className="flex flex-col ">
                        <p className="text-sm md:text-base lg:text-lg text-gray-400 mb-5">
                            Auction ends in 29d 3h 59m 59s
                        </p>

                        <h1 className="font-bold text-3xl lg:text-4xl xl:text-6xl mb-5">
                            {item.name}
                        </h1>
                        <p className="text-sm md:text-base lg:text-lg mb-2">
                            <span className = 'text-gray-500'>CREATED BY: </span> {item.creator}
                        </p>
                        <p className="text-sm md:text-base lg:text-lg mb-5">
                            <span className = 'text-gray-500'>OWNED BY: </span> {item.owner}
                        </p>

                        <div className="flex mb-3">
                            <div className="flex bg-gray-800 px-4 py-2 rounded-[8px] shadow-shadow3 mr-3">
                                <p className="text-sm md:text-base text-gray-300 mr-1">🎨</p>
                                <p className="text-sm md:text-base text-gray-300">Art</p>
                            </div>
                            <div className="flex bg-gray-800 px-4 py-2 rounded-[8px] shadow-shadow3 mr-3">
                                <p className="text-sm md:text-base text-gray-300 mr-1">👁</p>
                                <p className="text-sm md:text-base text-gray-300">Views</p>
                            </div>
                            <div className="flex bg-gray-800 px-4 py-2 rounded-[8px] shadow-shadow3 mr-3">
                                <p className="text-sm md:text-base text-gray-300 mr-1">♡</p>
                                <p className="text-sm md:text-base text-gray-300">Likes</p>
                            </div>
                            
                        </div>

                        <p className="text-sm md:text-base lg:text-lg text-gray-400 mb-10">
                            {item.description}
                        </p>

                        <p className="text-sm md:text-base lg:text-lg mb-3">
                            Attributes
                        </p>

                        <div className="flex flex-wrap">
                            <div className="flex flex-col justify-center p-3 m-2 shadow-shadow3 bg_gradient rounded-[8px]">
                                <p className="text-sm lg:text-base text-gray-300">
                                    GENERATION
                                </p>
                                <p className="text-sm lg:text-base">
                                    2
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px m-2 shadow-shadow3 bg_gradient rounded-[8px]">
                                <p className="text-sm lg:text-base text-gray-300">
                                    LINEAGE
                                </p>
                                <p className="text-sm lg:text-base">
                                    Stunt
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px m-2 shadow-shadow3 bg_gradient rounded-[8px]">
                                <p className="text-sm lg:text-base text-gray-300">
                                    PROGENITOR
                                </p>
                                <p className="text-sm lg:text-base">
                                    True
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px shadow-shadow3 m-2 bg_gradient rounded-[8px]">
                                <p className="text-sm lg:text-base text-gray-300">
                                    CREATOR
                                </p>
                                <p className="text-sm lg:text-base">
                                    {item.creator}
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px shadow-shadow3 m-2 bg_gradient rounded-[8px]">
                                <p className="text-sm lg:text-base text-gray-300">
                                    CANVAS
                                </p>
                                <p className="text-sm lg:text-base">
                                    80x80
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col mt-10 lg:mt-5">
                        
                            <div className="flex flex-col mb-3 sm:mb-0">
                                <p className="text-sm lg:text-base ">
                                    CURRENT BID 24.24
                                </p>
                                <p className="text-sm lg:text-base text-gray-300">
                                    MINIMUM BID: 11.34
                                </p>
                            </div>
                           
        

                            <div className="flex w-full p-3 shadow-shadow3 my-4 bg_gradient rounded-[8px]">
                                <p className="text-sm text-gray-300">
                                    Last Bid By: <span className="text-main">Stacy Mactens</span>, 11th May 2021 at 22:22:53 GMT +8
                                </p>
                            </div>

                            <div className="text-sm lg:text-base text-gray-400 lg:mx-2 mt-6">
                                <p>
                                    How it works:
                                </p>
                                <ul>
                                    <li>1. Connect your wallet and place a bid. The bid must be at least 0.25 SOL greater than the current bid</li>
                                    <li>2. You will automatically get your SOL returned to your wallet if outbid</li>
                                    <li>3. If a bid is received 5 minutes from the end of the auction, the bidding time will be extended by 5 minutes</li>
                                    <li>4. When auction closes, the artwork will belong to the highest bidder. Please claim the NFT by pressing the “claim item” button</li>
                                </ul>
                            </div>
                    </div>


                    </div>

                </div>

            </div>
        </div>
    )
}

export default ItemDetails;